import { apiGet } from './client';
import type { IdxType } from '../types/IdxType';

export function getIdxTypes(): Promise<IdxType[]> {
  return apiGet<IdxType[]>('/api/idx-types');
}
